const OpcUaServerCertificateStatus = {
  TRUSTED: "trusted",
  REJECTED: "rejected",
};

export default OpcUaServerCertificateStatus;
